module.exports = __webpack_public_path__ + "static/3-082a4590e18346c238c687c15f0bba60.png";